import { render, staticRenderFns } from "./projectservices.vue?vue&type=template&id=00e552f0&scoped=true"
import script from "./projectservices.vue?vue&type=script&lang=js"
export * from "./projectservices.vue?vue&type=script&lang=js"
import style0 from "./projectservices.vue?vue&type=style&index=0&id=00e552f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00e552f0",
  null
  
)

export default component.exports